export class EtapaAgentAIDifyModel {
  id?: number;
  url?: string
  token?: string;
  responseMode?: string;
  user?: string;
  variavelId?: number
  metodo?: string;
}
